import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { formatMoneda, validaMonto, formatoMonto } from "../../../util/varios";
import axios from "axios";
import useTableFijo from "../../useTableFijo";
import { AgregarDescuento } from "../actividadEconomica/modalAgregarDescuento";
import { Dimmer } from "../../spinner";
import { DangerButton, PrimaryButton, SuccessButton, WarningButton } from "../../../ui/buttons/Button";
import { Radio, Input } from "../../../ui/inputs/Input";

export const ModalConfiguracionInmuebles = (props) => {
  let heightTabla = 250;
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const [bloquear, setDesbloquear] = useState(true);
  const [bloquear2, setDesbloquear2] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    periodopago: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: 0,
    porcentajerecarg: 0,
    mesesdecladef: 0,
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: 0,
    diavendeudare: 0,
    declaracionwe: 0,
    notifrit: 0,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: 0,
  });
  const [activate, setActivate] = useState(false);
  const [itemSelect, setItemSelect] = useState(-1);
  const [mostrar1, setMostrar1] = useState(false);
  const txtInteresMora = useRef();
  const txtRecargoMora = useRef();
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "fechaini",
      label: "Periodo Inicio",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "fechafin",
      label: "Periodo Fin",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "dexcuento",
      label: "% Descuento",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];

  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    heightTabla
  );

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
  };

  const handleAgregarDescuento = (oper) => (e) => {
    e.preventDefault();
    setOperacion(oper);
    setMostrar1(true);
  };

  const handleRemove = (e) => {
    e.preventDefault();

    var i;
    var datos = [];
    for (i = 0; i < records.length; i++) {
      if (i !== itemSelect) {
        datos.push(records[i]);
      }
    }

    setItemSelect(-1);
    setRecords(datos);
  };

  const onChangeChecked = (e) => {
    if (e.target.name === "periodopago") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "tipointere") {
      if (e.target.value === "1") {
        setDesbloquear2(false);
      } else {
        txtInteresMora.current.value = "0,00";
        setDesbloquear2(true);
      }

      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "valorporcentua") {
      console.log("valor: " + e.target.value);
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
      console.log(values.valorporcentua);
    } else if (e.target.name === "declaracionwe") {
      setValues({
        ...values,
        [e.target.name]: e.target.value === "true" ? true : false,
      });
    }
  };
  const actualizarConfig = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);
    console.log(values.valorporcentua);
    body = {
      tipoconf: 2,
      periodo: parseInt(values.periodopago),
      factor: null,
      valor: parseInt(values.valorporcentua),
      decla: null,
      tipint: parseInt(values.tipointere),
      porint: txtInteresMora.current.value.replace(",", "."),
      porrec: txtRecargoMora.current.value.replace(",", "."),
      meses: null,
      diaven: null,
      diavenreg: null,
      pto: null,
      factor1: null,
      valormul: null,
      declaweb: values.declaracionwe,
      diavenqui1: null,
      diavenqui2: null,
      cmbMes: null,
      descu: records,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Configuración Actualizada.",
            icono: "exito",
          });
          seleccionnarModulo();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarDescuento = () => {
    let campos = "*";
    let nomtab = "tabladescuentos";
    let nomid = "tipoimpuesto";
    let id = 2;
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        let errorMessage = "Error desconocido";
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = "No se recibió respuesta del servidor";
        } else {
          errorMessage = "Error en la configuración de la solicitud";
        }
       /*  setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: errorMessage,
          icono: "error",
        }); */
        setActivate(false);
      });
  };

  const seleccionnarModulo = () => {
    let nomtab = "configinmueble";
    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
          seleccionarDescuento();
        }
      })
      .catch((error) => {
        let errorMessage = "Error desconocido";
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = "No se recibió respuesta del servidor";
        } else {
          errorMessage = "Error en la configuración de la solicitud";
        }
        /* setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: errorMessage,
          icono: "error",
        }); */
        setActivate(false);
      });
  };

  const handleCancelaDescuento = () => {
    setMostrar1(false);
    setItemSelect(-1);
  };

  const handleAceptaDescuento = (pini, pfin, porce) => {
    if (operacion === 1) {
      var valporce = porce === "" ? "0.00" : porce.replace(/\./g, "");
      var valorporce = valporce.replace(",", ".");
      setRecords([
        ...records,
        {
          tipoimpuesto: 1,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: valorporce,
        },
      ]);
    } else if (operacion === 2) {
      var i;
      var datos = [];
      for (i = 0; i < records.length; i++) {
        if (i !== itemSelect) {
          datos.push(records[i]);
        }
      }
      setItemSelect(-1);
      setRecords([
        ...datos,
        {
          tipoimpuesto: 1,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: porce,
        },
      ]);
    }
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };

  const salir = () => {
    props.onHideCancela();
  };

  const desbloquear = () => {
    setDesbloquear(false);
  };
  const handleInputMonto = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      console.log(event.target.value);
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setValues(props.configu);
        seleccionnarModulo();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">Configuracion de Inmuebles Urbanos</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 h-100">
          <div className="container text-dark" onClick={desbloquear}>
            <div className="row mx-auto">
              <div className="col-6 m-0 p-0">
                <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                  <legend className="float-none w-auto m-0">
                    Periodo de Pago
                  </legend>
                  <div class="col m-0 p-0">
                    <Radio label = "Anual"
                      value={1}
                      checked={values.periodopago === 1 ? true : false}
                      id="periodopag1"
                      name="periodopago"
                      onChange={onChangeChecked}
                    />
                  </div>

                  <div class="col m-0 p-0 mr-4">
                    <Radio label = "Trimestral"
                      value={2}
                      checked={values.periodopago === 2 ? true : false}
                      id="periodopag2"
                      name="periodopago"
                      onChange={onChangeChecked}
                    />
                  </div>

                  <div class="col m-0 p-0">
                    <Radio label = "Mensual"
                      value={3}
                      defaultChecked={
                        values.periodopago === 3 ? true : false
                      }
                      id="periodopag3"
                      name="periodopago"
                      onChange={onChangeChecked}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                  <legend className="float-none w-auto m-0">
                    Intereses de Mora
                  </legend>

                  <div class="col m-0 p-0">
                    <Radio label = "Fijo"
                      name="tipointere"
                      value={1}
                      checked={values.tipointere === 1 ? true : false}
                      id="tipointere1"
                      onChange={onChangeChecked}
                    />
                  </div>

                  <div className="col m-0 p-0">
                    <Radio label = "Según Tasa"
                      name="tipointere"
                      id="tipointere2"
                      disabled={bloquear2}
                      defaultValue={
                        values && values.porcentajeintere
                          ? formatMoneda(
                              values.porcentajeintere
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                      }
                      onKeyUp={handleInputMonto}
                      ref={txtInteresMora}
                    />
                  </div>

                  <div class="col m-0 p-0">
                    <Radio label = "Segun Tasa"
                      name="tipointere"
                      value={2}
                      checked={values.tipointere === 2 ? true : false}
                      id="tipointere3"
                      onChange={onChangeChecked}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                  <legend className="float-none w-auto m-0">
                    Valor Porcentual Alicuota
                  </legend>
                  <div class="col m-0 p-0">
                    <Radio label = "100"
                      name="valorporcentua"
                      value={1}
                      checked={values.valorporcentua === 1 ? true : false}
                      id="valorporcentua1"
                      onChange={onChangeChecked}
                    />
                  </div>
                  <div class="col m-0 p-0">
                    <Radio label = '1000'
                      name="valorporcentua"
                      value={2}
                      checked={values.valorporcentua === 2 ? true : false}
                      id="valorporcentua2"
                      onChange={onChangeChecked}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
                <legend className="float-none w-auto m-0">
                    Declaración en Linea (Internet)
                  </legend>
                  <div class="col m-0 p-0">
                    <Radio label = 'Si'
                      name=""
                      value={true}
                      checked={values.declaracionwe === true ? true : false}
                      id="declaracionwe1"
                      onChange={onChangeChecked}
                    />
                  </div>
                  <div class="col m-0 p-0">
                    <Radio label = 'No'
                      name="declaracionwe"
                      value={false}
                      checked={values.declaracionwe === false ? true : false}
                      id="declaracionwe2"
                      onChange={onChangeChecked}
                    />
                  </div>
                </fieldset>
                <div class="col-12 m-0 mt-2 p-0">
                  <Input label = 'Recargos por Mora'
                    defaultValue={
                      values && values.porcentajerecarg
                        ? formatMoneda(
                            values.porcentajerecarg
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                        : ""
                    }
                    onKeyUp={handleInputMonto}
                    ref={txtRecargoMora}
                  />
                </div>
              </div>
              <div className="col-6 m-0 p-0 pl-2 d-flex">
                <div className="col-10 m-0 p-0">
                  <TblContainer
                    container={{
                      height: 120,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <tbody>
                      {records &&
                        records.map((item, index) => (
                          <tr
                            key={index}
                            style={{
                              padding: "0",
                              background:
                                itemSelect === index ? "lightgreen" : "white",
                            }}
                            onClick={seleccionarFila(index)}
                          >
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "center",
                              }}
                            >
                              {item.periodoini}
                            </td>
                            <td
                              style={{
                                fontSize: "10px",
                                textAlign: "center",
                              }}
                            >
                              {item.periodofin}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {formatMoneda(
                                item.porcentaje.toString().replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <div className="col m-0 mt-2 p-0">
                    <PrimaryButton icon = 'fa-plus m-0'
                      onClick={handleAgregarDescuento(1)}
                    />
                  </div>
                  <div className="col m-0 mt-2 p-0">
                    <WarningButton icon = 'fa-edit m-0'
                      disabled={itemSelect === -1 ? true : false}
                      onClick={handleAgregarDescuento(2)}
                    />
                  </div>
                  <div className="col m-0 mt-2 p-0">
                    <DangerButton icon = 'fa-trash-alt m-0'
                      disabled={itemSelect === -1 ? true : false}
                      onClick={handleRemove}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton disabled={bloquear} onClick={actualizarConfig}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={salir}>Salir</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <AgregarDescuento
        show={mostrar1}
        tipoconf={operacion}
        descuento={records[itemSelect]}
        onHideAcepta={handleAceptaDescuento}
        onHideCancela={handleCancelaDescuento}
      />
      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
